// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__SLt8A","notes":"Notes_notes__2eVKl"};